import { useMutation, useQueryClient } from "react-query";
import { MedicalExaminationService } from "@services/medical-examination.service";
import { medicalExaminationQueryKeys } from "./queryKeys";

export const useUpdateMedicalExaminationCategoryMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(MedicalExaminationService.updateCategory, {
    onSuccess: () => {
      queryClient.invalidateQueries(medicalExaminationQueryKeys.all);
    },
  });
};
